<template>
    <div class="marketing-prefrences">
        <settings-template
            :isCustomMenu="true"
            :menuItems="menuItems"
            backUrl="/settings/home/internal"
        />
    </div>
</template>

<script>
import Feature from 'Services/Feature';
import SettingsTemplate from 'vcomponents/settings/SettingsTemplate.vue';

export default {
    components: {
        SettingsTemplate,
    },
    data() {
        return {
            menuItems: [],
        };
    },
    created() {
        if (Feature.isEnabled('sendethic')) {
            this.menuItems.push({
                label: this.$l10n.__('Synchronisation des champs'),
                routeName: 'marketing.preferences.attributes',
            });
        }

        if (Feature.isEnabled('rgpd-consent-v202312')) {
            this.menuItems.push({
                label: this.$l10n.__('Inscriptions aux campagnes'),
                routeName: 'marketing.preferences.consent',
            });
        }
    },
};
</script>
